import React from 'react';
import {connect} from 'react-redux';

import {isEmpty} from 'lodash';

import ActionBar from '../../components/ActionBar';
import SensorsTable from './SensorsTable';
import { TabContent } from '../../components/TabPanel';

import * as ArchitectActions from '../../actions/architectActions';
import * as BobActions from '../../actions/bobActions';

import classes from './TableAndSearch.module.css';

const SensorsTableAndSearch = ({
    fetchSensors,
    handleSort,
    isFullArchitectAllowed,
    onToggleDeleteSensorModal,
    onToggleEditSensorModal,
    onTogglePreviewDataModal,
    order,
    orderBy,
    resetCalculatedSensor,
    sensors,
    selectedNode,
    ...props
}) => {

    const handleSearch = searchFilter => {
        if (isEmpty(searchFilter)) {
            fetchSensors(selectedNode);
        } else {
            fetchSensors(selectedNode, {searchFilter});
        }
    };

    return (
        <TabContent
            classes={{
                root: classes.tabContent
            }}
        >
            <ActionBar
                onSearch={handleSearch}
            />
            <div className={classes.scrollContainer}>
                <SensorsTable
                    isFullArchitectAllowed={isFullArchitectAllowed}
                    sensors={sensors}
                    order={order}
                    orderBy={orderBy}
                    onSort={property => handleSort(props, property)}
                    onToggleDeleteSensorModal={onToggleDeleteSensorModal}
                    onToggleEditSensorModal={onToggleEditSensorModal}
                    onTogglePreviewDataModal={onTogglePreviewDataModal}
                    resetCalculatedSensor={resetCalculatedSensor}
                    selectedNode={selectedNode}
                />
            </div>
        </TabContent>
    );
};

const mapDispatchToProps = {
    ...ArchitectActions,
    ...BobActions
};

export default connect(null, mapDispatchToProps)(SensorsTableAndSearch);
